import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

export const getConsultantsApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/users/consultants`, { params });
};

export const createConsultantApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/admin/consultants`, data);
};

export const toggleConsultantStatusApi = (id, consultantStatus) => {
  return axios.patch(`${API_BASE_URL}/api/admin/consultants/${id}/status`, { consultantStatus });
};

export const listConsultantCategoriesApi = () => {
  return axios.get(`${API_BASE_URL}/api/admin/consultant-categories`);
};

export const createConsultantCategoryApi = (name) => {
  return axios.post(`${API_BASE_URL}/api/admin/consultant-categories`, { name });
};

export const deleteConsultantCategoryApi = (id) => {
  return axios.delete(`${API_BASE_URL}/api/admin/consultant-categories/${id}`);
};
